"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Progress = void 0;
var react_1 = __importDefault(require("react"));
var Progress = function Progress(_ref) {
  var progress = _ref.progress,
    total = _ref.total;
  return react_1.default.createElement("p", null, "".concat(progress, " / ").concat(total));
};
exports.Progress = Progress;